"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StorageStateDataGridProTable = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.reduce.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var _functions = require("../utils/functions");
const _excluded = ["localStorageId", "isClearFilters", "columns", "rows", "onStateChange", "Component"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const storageKeys = {
  state: 'state'
};
const StorageStateDataGridProTable = props => {
  const {
      localStorageId,
      isClearFilters,
      columns = [],
      rows = [],
      onStateChange,
      Component
    } = props,
    muiProps = _objectWithoutProperties(props, _excluded);
  const {
    host
  } = window.location;
  const getTableStorage = () => {
    const storage = (0, _functions.getFromLocalStorage)(host) || {};
    return storage[localStorageId] || {};
  };
  const getInitialState = () => {
    const tableStorage = getTableStorage();
    return tableStorage[storageKeys.state];
  };
  const getColumnOrders = () => {
    var _tableStorage$state;
    const tableStorage = getTableStorage();
    return (tableStorage === null || tableStorage === void 0 || (_tableStorage$state = tableStorage.state) === null || _tableStorage$state === void 0 || (_tableStorage$state = _tableStorage$state.columns) === null || _tableStorage$state === void 0 ? void 0 : _tableStorage$state.orderedFields) || [];
  };
  const [state, setState] = (0, _react.useState)(getInitialState());
  const [visibilityModel, setVisibilityModel] = (0, _react.useState)({});
  (0, _react.useEffect)(() => {
    var _state$columns;
    if (state !== null && state !== void 0 && (_state$columns = state.columns) !== null && _state$columns !== void 0 && _state$columns.columnVisibilityModel) {
      setVisibilityModel(state.columns.columnVisibilityModel);
    }
  }, [state]);
  const defineWidthForColumns = defaultColumns => {
    const clonedDefaultColumns = (0, _cloneDeep.default)(defaultColumns);
    return clonedDefaultColumns.map(defaultColumn => {
      var _state$columns2;
      if (state !== null && state !== void 0 && (_state$columns2 = state.columns) !== null && _state$columns2 !== void 0 && _state$columns2.lookup[defaultColumn.field]) {
        var _state$columns3;
        return _objectSpread(_objectSpread({}, defaultColumn), {}, {
          width: state === null || state === void 0 || (_state$columns3 = state.columns) === null || _state$columns3 === void 0 ? void 0 : _state$columns3.lookup[defaultColumn.field].width
        });
      }
      return defaultColumn;
    });
  };
  const sortColumnsAccordingToChangedOrder = definedWidthColumns => {
    const columnOrders = getColumnOrders();
    return columnOrders.reduce((accumulator, orderKey) => {
      const filteredKeyItemArray = definedWidthColumns.filter(item => item.field === orderKey)[0];
      accumulator.push(filteredKeyItemArray);
      return accumulator;
    }, []);
  };
  const modifyColumns = () => {
    const clonedColumns = (0, _cloneDeep.default)(columns);
    const columnsWithDefinedWidth = defineWidthForColumns(clonedColumns);
    const sortedByOrderColumns = sortColumnsAccordingToChangedOrder(columnsWithDefinedWidth);
    if (sortedByOrderColumns.length) {
      return sortedByOrderColumns;
    }
    return columnsWithDefinedWidth;
  };
  const [muiTableKey, setMuiTableKey] = _react.default.useState(0);
  const [modifiedColumns, setModifiedColumns] = (0, _react.useState)(modifyColumns());
  const saveDataToStorage = (0, _react.useCallback)(tableState => {
    if (!localStorageId) return;
    const {
      columnGrouping,
      columnMenu,
      columnReorder,
      columnResize,
      columns: columnsState,
      filter
    } = tableState;
    const storage = (0, _functions.getFromLocalStorage)(host) || {};
    (0, _functions.setToLocalStorage)(host, _objectSpread(_objectSpread({}, storage), {}, {
      [localStorageId]: _objectSpread(_objectSpread({}, storage[localStorageId]), {}, {
        state: {
          columnGrouping,
          columnMenu,
          columnReorder,
          columnResize,
          columns: columnsState,
          filter: {
            filterModel: filter.filterModel
          }
        }
      })
    }));
  }, [host, localStorageId]);
  (0, _react.useEffect)(() => {
    if (isClearFilters) {
      /** change key for reset all filters */
      setMuiTableKey(prev => prev + 1);
      setState(null);
      setVisibilityModel({});
      setModifiedColumns(columns);
      const storage = (0, _functions.getFromLocalStorage)(host) || {};
      (0, _functions.setToLocalStorage)(host, _objectSpread(_objectSpread({}, storage), {}, {
        [localStorageId]: {}
      }));
    }
  }, [isClearFilters, columns, host, localStorageId]);
  return /*#__PURE__*/_react.default.createElement(Component, _extends({}, muiProps, {
    key: muiTableKey,
    localStorageId: localStorageId,
    onStateChange: saveDataToStorage,
    columnVisibilityModel: visibilityModel,
    onColumnVisibilityModelChange: newModel => setVisibilityModel(newModel),
    initialState: state,
    rows: rows,
    columns: modifiedColumns
  }));
};
exports.StorageStateDataGridProTable = StorageStateDataGridProTable;
StorageStateDataGridProTable.propTypes = {
  localStorageId: _propTypes.default.string.isRequired,
  isClearFilters: _propTypes.default.bool,
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({})).isRequired,
  rows: _propTypes.default.arrayOf(_propTypes.default.shape({})).isRequired,
  onStateChange: _propTypes.default.func,
  Component: _propTypes.default.func.isRequired
};